import { createModel, createSaga, createReducer } from '@/store/tools';
import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';

const dataList = { dataList: [], pageNum: 1, pageSize: 20, resultTotal: 0 };
const model = {
    namespace: 'feedbacktype',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getFeedbackList': T('getFeedbackList'),
            'getRetaStatus': T('getRetaStatus'),
            'getHistoricalList': T('getHistoricalList'),
        },
        actions: {
            'getFeedbackList': A('getFeedbackList'), // 列表数据
            'getRetaStatus': A('getRetaStatus'), // 设置项下拉数据
            'getHistoricalList': A('getHistoricalList'), // 历史记录列表数据
        },
        sagas: {
            'getFeedbackList': S('getFeedbackList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.FeedBackService.pageFeedBackType', 'POST'),
            'getRetaStatus': S('getRetaStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getHistoricalList': S('getHistoricalList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.RatioSettingHistoryMisService.listRatioSettingHistoryBySettingName', 'POST'),
        },
        reducers: {
            'feedbackList': R('getFeedbackList', dataList),
            'rateStatus': R('getRetaStatus', []),
            'historicalList': R('getHistoricalList', []),
        }
    })
};
export default createModel(model);